import { render, staticRenderFns } from "./VBlogForm.vue?vue&type=template&id=fa80ce32"
import script from "./VBlogForm.vue?vue&type=script&lang=js"
export * from "./VBlogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports